import 'phaser';

import GameScene from './scenes/GameScene';

let game = null;

window.onload = function() {
	var config = {
		type: Phaser.AUTO,
	    scale: {
	        mode: Phaser.Scale.Fit,
	        parent: 'main',
	        width: '100%',
	        height: '100%',
	    },
        physics: {
            default: "arcade"
        },
		scene: [
			GameScene
		]
	};

	game = new Phaser.Game(config);
    
    window.focus()
}